export const GLOBAL_ERROR = 'GLOBAL_ERROR';

export const DATE_DISPLAY_FORMAT = 'dd MMM yyyy';

export const SETTLEMENT_STATUSES = {
  draft: 'draft',
  orderAccepted: 'orderAccepted',
  documentsReady: 'documentsReady',
  documentsApproved: 'documentsApproved',
  carReady: 'carReady',
  carDelivered: 'carDelivered'
};

export const INITIAL_USER = {
  profile: {
    companyName: undefined,
    companyEmail: undefined,
    postcode: undefined,
    contactNumber: undefined
  },
  entity: undefined,
  permissions: []
};

export const INITIAL_APPLICATION = {
  applicationId: undefined,
  applicationStatus: undefined,
  metaData: {}
};

export const INITIAL_QUOTE = {
  quoteId: undefined,
  erpQuoteRef: undefined,
  status: undefined,
  bodyType: undefined,
  variant: {
    gears: undefined,
    doors: undefined,
    modelYear: undefined,
    fuelTankCapacity: undefined,
    transmission: undefined,
    photos: []
  },
  exteriorColour: {
    name
  }
};

export const INITIAL_SETTLEMENT = {
  approximateDelivery: undefined,
  confirmedDelivery: undefined,
  dealer: {
    location: undefined,
    name: undefined
  },
  status: undefined,
  orderId: undefined,
  hasDocusign: undefined,
  deliveryMessage: undefined
};

export const DEFAULT_WIDGET_PROPS = {
  mountSelector: '#settlement-app',
  user: { ...INITIAL_USER }
};

export const WIDGET_REQUIRED_PROPS = [
  'mountSelector',
  'user',
  'application',
  'quote'
];
